import { LOGO_URL } from "../../lib/troy";
import { Gift, MessageSquareHeart, Sparkles, Trophy, ArrowRight } from "lucide-react";

const DISCOUNTS = ["5%", "10%", "20%", "30%", "50%", "100%"];

const HEADPHONE_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_urban-rides-26/artifacts/zelu2r85_f9dfc855-2630-4d22-abbb-adf04e68ed35.png";
const JBL_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_urban-rides-26/artifacts/emhgxxoo_JBL_XTREME_4_HERO_BLACK_47136_X2_%281%29%20%281%29.webp";

export default function FeedbackPromo() {
  return (
    <section
      id="promo-roleta"
      data-testid="feedback-promo-banner"
      className="relative pt-24 md:pt-28 pb-6 md:pb-8 bg-[#08080A]"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 md:px-10">
        <div className="card-accent-top relative rounded-3xl bg-gradient-to-br from-[#18181C] via-[#121215] to-[#1A0F0F] border border-[#FFCC00]/30 p-6 sm:p-8 md:p-10 overflow-hidden shadow-[0_0_50px_rgba(255,204,0,0.15)] promo-glow">
          {/* Roleta decorativa girando */}
          <div className="absolute -right-16 -top-16 w-56 h-56 sm:w-72 sm:h-72 rounded-full roulette-wheel opacity-20 pointer-events-none" />
          <div className="absolute -left-10 -bottom-10 w-40 h-40 rounded-full bg-[#FF3B30]/15 blur-3xl pointer-events-none" />

          <div className="relative grid md:grid-cols-12 gap-6 md:gap-8 items-center">
            <div className="md:col-span-8">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={LOGO_URL}
                  alt="Troy Transportes"
                  className="logo-ring w-11 h-11 sm:w-12 sm:h-12 rounded-xl object-contain bg-black/80 border border-[#FFCC00]/30 shrink-0"
                />
                <span className="inline-flex items-center gap-1.5 text-[10px] sm:text-xs font-black uppercase tracking-[0.2em] text-[#FFCC00] bg-[#FFCC00]/10 border border-[#FFCC00]/30 px-3 py-1.5 rounded-full animate-pulse">
                  <Sparkles className="w-3.5 h-3.5" /> Roleta Troy
                </span>
              </div>

              <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-black tracking-tight leading-tight mb-3">
                🎁 DÊ SUA OPINIÃO E{" "}
                <span className="text-[#FFCC00]">GANHE UMA CHANCE!</span>
              </h2>
              <p className="text-white/75 text-sm sm:text-base leading-relaxed max-w-xl">
                Envie seu feedback para a Troy e libere sua participação na{" "}
                <strong className="text-white">Roleta de Descontos</strong>.
              </p>
              <p className="mt-2 font-display text-lg sm:text-xl font-bold text-[#FF6B63]">
                🎰 Prêmios de até 100% de desconto
              </p>
              <p className="text-white/50 text-xs sm:text-sm mt-1">
                É rápido, gratuito e você só precisa participar uma vez por número.
              </p>

              {/* Prêmios físicos em destaque */}
              <div
                data-testid="promo-prizes"
                className="mt-5 flex items-center gap-3 flex-wrap"
              >
                <span className="inline-flex items-center gap-1.5 text-[11px] sm:text-xs font-black uppercase tracking-[0.15em] text-[#FFCC00]">
                  <Trophy className="w-4 h-4" /> Concorra também a:
                </span>
                <div className="flex items-center gap-2.5">
                  <div className="group flex items-center gap-2 rounded-xl bg-black/50 border border-[#FFCC00]/30 pl-1.5 pr-3 py-1.5 shadow-[0_0_18px_rgba(255,204,0,0.12)]">
                    <span className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-white shadow-inner">
                      <img
                        src={HEADPHONE_IMG}
                        alt="Fone Bluetooth"
                        className="w-7 h-7 sm:w-8 sm:h-8 object-contain"
                      />
                    </span>
                    <span className="text-[11px] sm:text-xs font-bold text-white leading-tight">
                      Fone<br className="hidden sm:block" /> Bluetooth
                    </span>
                  </div>
                  <div className="group flex items-center gap-2 rounded-xl bg-black/50 border border-[#FFCC00]/30 pl-1.5 pr-3 py-1.5 shadow-[0_0_18px_rgba(255,204,0,0.12)]">
                    <span className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-white shadow-inner">
                      <img
                        src={JBL_IMG}
                        alt="Caixa de som JBL"
                        className="w-7 h-7 sm:w-8 sm:h-8 object-contain"
                      />
                    </span>
                    <span className="text-[11px] sm:text-xs font-bold text-white leading-tight">
                      Caixinha<br className="hidden sm:block" /> de Som
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="md:col-span-4 flex flex-col items-center md:items-end gap-4">
              <a
                href="#feedback"
                data-testid="promo-feedback-btn"
                className="w-full md:w-auto inline-flex items-center justify-center gap-2 bg-[#FFCC00] text-black font-black text-base sm:text-lg py-4 px-6 sm:px-8 rounded-xl hover:bg-[#E6B800] transition-all transform hover:-translate-y-0.5 shadow-[0_0_35px_rgba(255,204,0,0.45)] animate-[pulseGlowYellow_2.4s_ease-in-out_infinite] text-center"
              >
                <MessageSquareHeart className="w-5 h-5 shrink-0" />
                💬 DEIXAR MEU FEEDBACK
              </a>

              <div className="flex flex-col items-center md:items-end gap-1.5">
                <div className="flex items-center gap-1.5 flex-wrap justify-center" data-testid="promo-discounts">
                  <Gift className="w-4 h-4 text-[#FFCC00]" />
                  {DISCOUNTS.map((d) => (
                    <span
                      key={d}
                      className="text-[11px] sm:text-xs font-black px-2 py-1 rounded-md bg-[#FF3B30]/15 text-[#FFCC00] border border-[#FFCC00]/25"
                    >
                      {d}
                    </span>
                  ))}
                </div>
                <p className="text-white/50 text-[11px] sm:text-xs">
                  Envie seu feedback e descubra seu desconto.
                </p>
              </div>
            </div>
          </div>
        </div>

        <a
          href="#motoristas"
          data-testid="promo-driver-shortcut"
          className="mt-4 flex items-center justify-between gap-3 rounded-2xl bg-[#121215] border border-[#FFCC00]/25 px-5 py-4 hover:border-[#FFCC00]/60 hover:bg-[#17171b] transition-all group"
        >
          <span className="flex items-center gap-3">
            <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-black/70 border border-[#FFCC00]/30 shrink-0 overflow-hidden">
              <img
                src={LOGO_URL}
                alt="Carro da Troy"
                className="w-full h-full object-contain p-0.5"
              />
            </span>
            <span className="leading-tight">
              <span className="block font-display font-black text-base sm:text-lg text-white">
                Quer ser motorista Troy? Cadastre-se aqui
              </span>
            </span>
          </span>
          <span className="inline-flex items-center gap-1.5 text-[#FFCC00] font-bold text-xs sm:text-sm shrink-0">
            Cadastrar
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </span>
        </a>
      </div>
    </section>
  );
}
